import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import './Blogpage.css';

export const Blogpage = () => {
    const { slugurl } = useParams(); // Get the slugurl from the URL
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchBlog = async () => {
            try {
                const response = await axios.get(`https://harasky.com/api/user/api.php?slugurl=${slugurl}`);
                if (response.data) {
                    setBlog(response.data); // Set the blog data
                } else {
                    setError("Blog not found");
                }
            } catch (error) {
                console.error("Error fetching blog:", error);
                setError("Failed to fetch blog");
            } finally {
                setLoading(false);
            }
        };

        fetchBlog();
    }, [slugurl]); // Re-fetch when slugurl changes

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    if (!blog) {
        return <div>No blog data found.</div>;
    }

    return (
        <div>
            <section className="BlogBannerDivMain">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="BlogBannerDiv">
                                <p>{blog.btitle}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 mx-auto">
                            <div className="blogImgBlogpage">
                                <img src={`https://harasky.com/api/uploads/${blog.bimg}`} alt={blog.btitle} />
                            </div>
                            <div className="blogDetails">
                                <p>Written By: {blog.authorname}</p>
                                <p>{new Date(blog.bdate).toLocaleDateString()}</p>
                                <h2>{blog.btitle}</h2>
                            </div>
                            <div className="blogBody">
                                  <div dangerouslySetInnerHTML={{ __html: blog.blogtext }} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};